import SwipeableCards from './container';

export default SwipeableCards;



// WEBPACK FOOTER //
// ./src/components/Steps/SwipeableCards/index.js